import { fetchWithToken, getWithToken, postWithToken } from "../authentication/AuthProvider";
import config, { apiUrl } from "../config";

const project = apiUrl + "/project";
const routes = {
  label: "Project",
  value: "project",
  root: project,
  new: project + "/new",
  delete: project + "/delete",
  update: project + "/update",
  update_bulk: project + "/update_bulk",
  archive: project + "/archive",
  unarchive: project + "/unarchive",
  hide: project + "/hide",
  unhide: project + "/unhide",
  get_hidden: project + "/get_hidden",
  collaborate: project + "/collaborate",
  uncollaborate: project + "/uncollaborate",
  duplicate: project + "/duplicate",
  save_project_info: project + "/save_project_info",
  save_scope_and_goals: project + "/save_scope_and_goals",
  save_supplier_info: project + "/save_supplier_info",
  get_photo: project + "/get_photo",
  get_spec_document: project + "/get_spec_document",
  get_safety_document: project + "/get_safety_document",
  get_published_template: project + "/get_published_template",
  get_from_admin: project + "/get_from_admin",
  get_pending_validation: project + "/get_pending_validation",
  get_mine: project + "/get_mine",
  get_from_my_workspace: project + "/get_from_my_workspace",
  get_my_company_archive: project + "/get_my_company_archive",
  get_internal_collaborates: project + "/get_internal_collaborates",
  get_external_collaborates: project + "/get_external_collaborates",
  get_mine_collaborates: project + "/get_mine_collaborates",
  get_total_gwp_by_env_type: project + "/get_total_gwp_by_env_type",
  get_total_gwp_by_stage: project + "/get_total_gwp_by_stage",
  get_by_id: project + "/get_by_id",
  generate_insight_5_0: project + "/generate_insight_5_0",
  generate_insight_3_5: project + "/generate_insight_3_5",
  generate_insight_deepseek: project + "/generate_insight_deepseek",
  generate_insight_gemini_flash: project + "/generate_insight_gemini_flash",
  generate_insight_gemini_flash_lite: project + "/generate_insight_gemini_flash_lite",
  generate_insight_gemini_pro: project + "/generate_insight_gemini_pro",
  get_insight: project + "/get_insight",

  set_validation_status: project + "/set_validation_status",
  request_validation: project + "/request_validation",
  retrieve: project + "/retrieve",
};
export const Project = {
  label: routes.label,
  value: routes.value,

  new: (data) => postWithToken(routes.new, data),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  update: (project) => postWithToken(routes.update, project),
  update_bulk: (projects) => postWithToken(routes.update_bulk, projects),

  archive: (ids) => postWithToken(routes.archive, { ids }),
  unarchive: (ids) => postWithToken(routes.unarchive, { ids }),

  hide: (ids) => postWithToken(routes.hide, { ids }),
  unhide: (ids) => postWithToken(routes.unhide, { ids }),
  get_hidden: () => postWithToken(routes.get_hidden),

  collaborate: (ids) => postWithToken(routes.collaborate, { ids }),
  uncollaborate: (ids) => postWithToken(routes.uncollaborate, { ids }),

  duplicate: (ids) => postWithToken(routes.duplicate, { ids }),

  get_mine: () => postWithToken(routes.get_mine),
  get_insight: (project_id) => postWithToken(routes.get_insight, { project_id }),
  get_from_my_workspace: () => postWithToken(routes.get_from_my_workspace),
  get_published_template: () => getWithToken(routes.get_published_template),
  get_from_admin: () => postWithToken(routes.get_from_admin),
  get_pending_validation: () => getWithToken(routes.get_pending_validation),
  get_photo: (id) => postWithToken(routes.get_photo, { id }),
  get_spec_document: (id) => postWithToken(routes.get_spec_document, { id }),
  get_safety_document: (id) => postWithToken(routes.get_safety_document, { id }),
  get_mine_collaborates: () => postWithToken(routes.get_mine_collaborates),
  get_my_company_archive: () => getWithToken(routes.get_my_company_archive),
  get_external_collaborates: () => postWithToken(routes.get_external_collaborates),
  get_internal_collaborates: () => postWithToken(routes.get_internal_collaborates),
  get_total_gwp_by_env_type: (project_ids) => getWithToken(routes.get_total_gwp_by_env_type, { project_ids }),
  get_total_gwp_by_stage: (project_ids) => getWithToken(routes.get_total_gwp_by_stage, { project_ids }),
  get_by_id: (id) => postWithToken(routes.get_by_id, { id }),

  save_project_info: (form) => fetchWithToken(routes.save_project_info, { ...config.method.POST, body: form }),
  save_scope_and_goals: (form) => fetchWithToken(routes.save_scope_and_goals, { ...config.method.POST, body: form }),
  save_supplier_info: (form) => fetchWithToken(routes.save_supplier_info, { ...config.method.POST, body: form }),

  generate_insight_3_5: (project_id) => postWithToken(routes.generate_insight_3_5, { project_id }),
  generate_insight_5_0: (project_id) => postWithToken(routes.generate_insight_5_0, { project_id }),
  generate_insight_deepseek: (project_id) => postWithToken(routes.generate_insight_deepseek, { project_id }),
  generate_insight_gemini_flash: (project_id) => postWithToken(routes.generate_insight_gemini_flash, { project_id }),
  generate_insight_gemini_flash_lite: (project_id) => postWithToken(routes.generate_insight_gemini_flash_lite, { project_id }),
  generate_insight_gemini_pro: (project_id) => postWithToken(routes.generate_insight_gemini_pro, { project_id }),

  request_validation: (ids) => postWithToken(routes.request_validation, { ids }),
  set_validation_status: ({ id, validation_status }) => postWithToken(routes.set_validation_status, { id, validation_status }),
  retrieve: (ids) => postWithToken(routes.retrieve, { ids }),
};
